
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/s/pricing-1",
      function () {
        return require("private-next-pages/cleartax.in/s/pricing-1/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/s/pricing-1"])
      });
    }
  